<app-spinner [active]="loading"></app-spinner>
<div class="dashboard-container">
  <div>
    <div class="success-banner">
      <mat-icon class="icon">check_circle</mat-icon>
      <span>The Smokejumper Reporting System is now live. This system replaces the legacy MADB and MARS applications as the new system of record.</span>
    </div>
    <div class="dashboard">
      <div class="block-a">
        <div class="card" *ngFor="let card of cardsBlockA" [ngClass]="card.class">
          <button (click)="go(card.route)" *ngIf="card.description" mat-button class="route-btn">
            <div class="btn-col">

              <span *ngIf="!card.image" class="title">{{ card.title }}</span>
              <span class="description" > {{ card.description }}</span>
            </div>
            <mat-icon class="icon arrow">east</mat-icon>
          </button>
          <div class="image-container" *ngIf="card.image">
            <img class="image" [src]="card.image" [alt]="card.alt" [ngClass]="card.imgClass" >
          </div>
          <img class="icon" [src]="card.icon" [alt]="card.alt" *ngIf="card.icon"/>
          <span class="stat" *ngIf="card.stat !== null">{{ card.stat }}</span>
          <span class="stat-detail" *ngIf="card.statDetail">{{ card.statDetail }}</span>
        </div>
      </div>
      <div class="block-b">
        <div class="card" *ngFor="let card of cardsBlockB" [ngClass]="card.class">
          <button (click)="go(card.route)" *ngIf="card.description" mat-button class="route-btn">
            <span *ngIf="!card.image" class="title">{{ card.title }}</span>
            <span class="description" > {{ card.description }}</span>
            <mat-icon class="icon arrow">east</mat-icon>
          </button>
          <div class="image-container" *ngIf="card.image" [ngClass]="{'double': card.class === 'double-square'}">
            <img class="image" [src]="card.image" [alt]="card.alt" [ngClass]="card.imgClass"  >
          </div>
          <img class="icon" [src]="card.icon" [alt]="card.alt" *ngIf="card.icon"/>
          <span class="stat" *ngIf="card.stat !== null">{{ card.stat }}</span>
          <span class="stat-detail" *ngIf="card.statDetail">{{ card.statDetail }}</span>
        </div>  
      </div>
      <div class="block-c">
        <div class="card" *ngFor="let card of cardsBlockC" [ngClass]="card.class">
          <button (click)="go(card.route)" *ngIf="card.description" mat-button class="route-btn">
            <span *ngIf="!card.image" class="title">{{ card.title }}</span>
            <span class="description" > {{ card.description }}</span>
            <mat-icon class="icon arrow">east</mat-icon>
          </button>
          <div class="image-container" *ngIf="card.image" [ngClass]="{'double': card.class === 'double-square'}">
            <img class="image" [src]="card.image" [alt]="card.alt" [ngClass]="card.imgClass"  >
          </div>
          <img class="icon" [src]="card.icon" [alt]="card.alt" *ngIf="card.icon"/>
          <span class="stat" *ngIf="card.stat !== null">{{ card.stat }}</span>
          <span class="stat-detail" *ngIf="card.statDetail">{{ card.statDetail }}</span>
        </div>  
      </div>
    </div>
  </div>
  <footer class="footer-info" >
    <div class="footer-left">
      <a href="https://www.fs.usda.gov/">
        <img class="desktop" src="assets/images/usda.png" alt="USDA Forest Service Logo" />
      </a>
      <a class="version" (click)="go('version-history')" >version {{ version }}</a>
    </div>
    <div class="social-icons">
      <div class="contact-info">
        <span>Contact Support</span>
        <a href="mailto:sm.fs.smokejumper@usda.gov" class="email">
          sm.fs.smokejumper&#64;usda.gov
        </a>
      </div>
      <a
        href="https://www.facebook.com/USForestService"
        class="social-icon"
      >
        <img src="assets/icons/facebook.svg" alt="Facebook"/>
      </a>
      <a
        href="https://x.com/forestservice"
        class="social-icon"
      >
        <img src="assets/icons/twitter.svg" alt="Twitter"/>
      </a>
      <a
        href="https://www.youtube.com/@usdaForestService"
        class="social-icon"
      >
        <img src="assets/icons/youtube.svg" alt="Youtube"/>
      </a>
      <a
        href="https://www.usda.gov/rss-feeds"
        class="social-icon"
      >
        <img src="assets/icons/rssFeed.svg" alt="usda rss feed"/>
      </a>
    </div>
  </footer>
</div>
  
